module.exports = __webpack_public_path__ + "img/error.6a02b65c.png";